class UpsellProductCard extends HTMLElement {
  connectedCallback() {
    this._primaryImg = this.querySelector('[data-upsell-primary-image]');
    this._defaultPrimarySrc = this._primaryImg
      ? this._primaryImg.getAttribute('data-default-src')
      : null;

    this.querySelectorAll('.card__swatch').forEach((btn) => {
      btn.addEventListener('click', this._onSwatchClick.bind(this));
    });

    const moreBtn = this.querySelector('[data-swatch-more]');
    if (moreBtn) moreBtn.addEventListener('click', this._onMoreClick.bind(this));
  }

  _onSwatchClick(e) {
    const btn = e.currentTarget;

    this.querySelectorAll('.card__swatch').forEach((b) => {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    const primaryImg = btn.dataset.primaryImage;
    if (this._primaryImg) {
      this._primaryImg.src = primaryImg || this._defaultPrimarySrc;
      this._primaryImg.srcset = '';
      this._primaryImg.removeAttribute('width');
      this._primaryImg.removeAttribute('height');
    }

    const productUrl = btn.dataset.productUrl;
    const productTitle = btn.dataset.productTitle;

    if (productUrl) {
      this.querySelectorAll('[data-upsell-product-link]').forEach((link) => {
        link.href = productUrl;
      });
    }

    if (productTitle) {
      const titleText = this.querySelector('[data-upsell-title-text]');
      if (titleText) titleText.textContent = productTitle;
    }

    this._updatePrice(
      btn.dataset.price,
      btn.dataset.comparePrice,
      btn.dataset.onSale === 'true',
      btn.dataset.soldOut === 'true'
    );

    try {
      const sizes = JSON.parse(btn.dataset.sizes || '[]');
      this._updateAction(
        sizes,
        productUrl,
        btn.dataset.firstVariantId,
        btn.dataset.soldOut === 'true'
      );
    } catch (_) {}
  }

  _updatePrice(price, comparePrice, onSale, soldOut) {
    const priceEl = this.querySelector('.price');
    if (!priceEl) return;

    priceEl.classList.toggle('price--on-sale', onSale);
    priceEl.classList.toggle('price--sold-out', soldOut);

    const regularEl = priceEl.querySelector('.price__regular .price-item--regular');
    if (regularEl) regularEl.innerHTML = price || '';

    const salePriceEl = priceEl.querySelector('.price-item--sale');
    if (salePriceEl) salePriceEl.innerHTML = price || '';

    const compareEl = priceEl.querySelector('.price__sale s.price-item--regular');
    if (compareEl) compareEl.innerHTML = comparePrice || '';
  }

  _updateAction(sizes, productUrl, firstVariantId, soldOut) {
    const selectSizeWrapper = this.querySelector('[data-upsell-select-size-wrapper]');
    const atcWrapper = this.querySelector('[data-upsell-atc-wrapper]');
    const hasSizes = sizes.length > 0;

    if (selectSizeWrapper) {
      selectSizeWrapper.hidden = !hasSizes;
      if (hasSizes && productUrl) {
        // Update the quick-view trigger button with the new product URL
        const quickViewBtn = selectSizeWrapper.querySelector('[data-quick-view-btn]');
        if (quickViewBtn) quickViewBtn.setAttribute('data-product-url', productUrl);
      }
    }

    if (atcWrapper) {
      atcWrapper.hidden = hasSizes;
      if (!hasSizes && firstVariantId) {
        const variantInput = atcWrapper.querySelector('.product-variant-id');
        if (variantInput) variantInput.value = firstVariantId;
        const submitBtn = atcWrapper.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = soldOut;
      }
    }
  }

  _onMoreClick(e) {
    e.currentTarget.hidden = true;
    this.querySelectorAll('.card__swatch--hidden').forEach((btn) => {
      btn.classList.remove('card__swatch--hidden');
    });
  }
}

if (!customElements.get('upsell-product-card')) {
  customElements.define('upsell-product-card', UpsellProductCard);
}

// When quick-view drawer closes, restore cart drawer scroll lock if it is still open
document.body.addEventListener('modalClosed', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && cartDrawer.classList.contains('active')) {
    document.body.classList.add('overflow-hidden');
  }
});
